import { render } from "./ContentLockedMessage.vue?vue&type=template&id=767801bc"
import script from "./ContentLockedMessage.vue?vue&type=script&lang=js"
export * from "./ContentLockedMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__